import React, { useMemo } from "react";
import styles from "./AdminHeader.module.css";
import { Icon, IconButton, Text, Button } from "@zorni/components-lib";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const formatCurrentDate = () =>
  new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(new Date());

const AdminHeader = ({ activeRouteMeta, onToggleSidebar, isMobile = false }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentDate = useMemo(() => formatCurrentDate(), []);

  return (
    <header className={styles.root}>
      <div className={styles.left}>
        {isMobile && (
          <IconButton
            iconName="iconHamburger"
            aria-label="Ouvrir le menu"
            onClick={onToggleSidebar}
            className={styles.menuButton}
          />
        )}

        <span className={styles.titleIcon}>
          <Icon name={activeRouteMeta?.icon || "iconGrid"} size="lg" color="primary" />
        </span>

        <div className={styles.titleBlock}>
          <Text as="span" size="xl" weight="semibold" className={styles.titleText}>
            {t(activeRouteMeta?.labelKey || "commons.labels.dashboard")}
          </Text>
        </div>
      </div>

      <div className={styles.right}>
        <Button
          variant="secondary"
          size="small"
          label="Espace client"
          iconName="iconArrowSquareOut"
          iconPosition="left"
          onClick={() => navigate("/")}
          className={styles.clientButton}
        />
        <div className={styles.separator} aria-hidden="true" />
        <Text as="span" size="sm" color="muted" className={styles.dateText}>
          {currentDate}
        </Text>
      </div>
    </header>
  );
};

export default AdminHeader;
